import { IconCheck } from '../Icon';
import UserBadge from '../UserBadge';

export default function BusinessOwnerBadge() {
  return (
    <UserBadge text="Business Owner" color="blue" icon={<IconCheck width={11} height={12} />} />
  );
}
